module.exports = __webpack_public_path__ + "media/images/top/seminars/top/img_flow-63b7e8688ce921df6d5a5cbb7b00e520.png";